import { createFileRoute } from '@tanstack/react-router'
import { RegularLink } from '../components/inline/RegularLink'
import SignupStripeCard from '@/components/home/SignupStripeCard'

export const Route = createFileRoute('/signup')({
  component: SignupPage,
})

function SignupPage() {
  return (
    <div
      // className="min-h-screen flex flex-col items-center justify-center px-6"
      className="min-h-screen"
      style={{
        background:
          'radial-gradient(ellipse 80% 60% at 20% 20%, rgba(147, 51, 234, 0.12) 0%, transparent 60%), ' +
          'radial-gradient(ellipse 70% 50% at 80% 80%, rgba(249, 115, 22, 0.14) 0%, transparent 60%), ' +
          '#fafaf9',
      }}
    >
      <div className="flex flex-col items-center justify-center px-6">
        <div className="max-w-xl w-full text-center">
          {/* Logo mark */}
          <div className="flex justify-center mb-8">
            <span className="w-14 h-14 rounded-full bg-gradient-to-br from-purple-600 to-orange-500 shadow-lg" />
          </div>

          {/* <TranslucentSlideThing> */}
          <h1 className="text-5xl font-extrabold tracking-tight mb-5 bg-clip-text text-transparent bg-gradient-to-r from-purple-600 to-orange-500">
            Sign up!
          </h1>
          {/* </TranslucentSlideThing> */}

          {/* <TranslucentSlideThing> */}
          <p className="text-lg text-stone-600 dark:text-stone-400 leading-relaxed mb-10 max-w-prose mx-auto">
            Choose a plan below.{' '}
            {/* <span className="text-stone-500 dark:text-mist-400 italic">— Marshall</span> */}
          </p>
          {/* </TranslucentSlideThing> */}
        </div>

        <div className="min-w-full px-6">
          <SignupStripeCard/>
          {/* <script async src="https://js.stripe.com/v3/pricing-table.js"></script>
          <stripe-pricing-table pricing-table-id="prctbl_1U6wGFAxug2Hf1uMJwp1LPCx"
          publishable-key="pk_live_51TbPoRAxug2Hf1uMC5pSUoPRHP4enPxEBJmaVvDNhvVaLLG5s1W1PrCMNGIJ0NeHYmaOpbH79PPYkOhyACevfzwk00et5G9UIE">
          </stripe-pricing-table> */}
        </div>

        <RegularLink
          to="/"
          className="inline-flex items-center gap-2 font-medium transition-colors"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 19l-7-7 7-7"
            />
          </svg>
          Back to home
        </RegularLink>
      </div>
    </div>
  )
}
